<template>
  <div style="background-color: #F6F6F6;padding-top: 64px;">
    <!-- 企业标签 -->
    <div class="shade" v-if="islabel==true"></div>
    <div class="releaseJob-tabel" v-if="islabel==true">
      <div class="releaseJob-tabel-title">
        <div>请选择企业标签（多选）</div>
        <img src="../../assets/close.png" @click="close()" alt="">
      </div>
      <div class="releaseJob-tabels">
        <div v-for="(item, index) in tagList" :key="index">
          <div class="releaseJob-tabels-tabel" :class="item.check==true ? 'releaseJob-tabel-actives':''" @click="select(index, item.check)">{{item.name}}</div>
        </div>
      </div>
      <div class="releaseJob-tabel-btns">
        <div @click="selectTabel()">确认</div>
        <div @click="close()">取消</div>
      </div>
    </div>
    <!-- 企业标签 -->
    <div style="background-color: rgb(246, 246, 246);width: 1200px;margin: 0 auto;margin-top: 27px;">
      <div class="enterpriseDetails-bottom">
        <!--新2023-4-26-->
        <div class="resume-box-releaseJobVue">
          <!--2023-4-24-->
          <div class="resume-left-releaseJobVue">
            <div class="resume-modular-filling-releaseJobVue">
              <!--职位信息-->
              <div class="resume-modular-fillBox-releaseJobVue">
                <img src="../../assets/index-line.png" style="margin-bottom: 20px;" alt="">
                <div class="resume-modular-title-name-releaseJobVue">
                  <div style="display: inline-block;font-size: 22px">企业基本信息</div>
                </div>
                <!-- 企业名称、信用代码-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue">企业名称</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <input v-model="jobCompany.name" disabled class="resume-fill-detils-releaseJobVue" type="text">
                    </div>
                  </div>
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue">信用代码</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <input v-model="jobCompany.code" disabled class="resume-fill-detils-releaseJobVue" type="text">
                    </div>
                  </div>
                </div>
                <!-- 企业名称、信用代码-->
                <!-- 营业执照、企业logo-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue">营业执照</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <!--上传企业营业执照-->
                      <div style="width: 165px;float: left" :style="backgroundDiv">
                        <div :style="{'height': licenseUrl==''?'126px':'126px'}" class="enterpriseDetails-fillDetails enterpriseDetails-fillDetails-headerPhoto">
                          <div class="enterpriseDetails-fillDetails-headerPhoto-after" style="cursor: pointer" @click="changeUrlBig()">
                            <img v-if="licenseUrl!=''" :src="licenseUrl" style="height:100%;width:100%;"/>
                          </div>
                        </div>
                      </div>
                      <div style="height: 24px;width: 165px;float: left;cursor: pointer;padding: 10px 0;position: relative;margin: 42px 0 42px 26px">
                        <img src="../../assets/enterpriseInfomationAddImgBtn.png" class="enterpriseInfomationAddImgBtn" alt="上传按钮">
                        <div v-if="licenseUrl==null" style="height: 24px;float: left">点击上传</div>
                        <div v-if="licenseUrl!=null" style="height: 24px;float: left">重新上传</div>
                        <input ref="fileInputs" type="file" v-on:change="licenseUrls()" class="enterpriseDetails-fillDetails-headerPhoto-file-bigImg"  style="cursor: pointer" >
                      </div>
                    </div>
                  </div>
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue">企业logo</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <!--上传企业logo-->
                      <div style="width: 165px;float: left;" :style="backgroundDiv">
                        <div :style="{'height': logoUrl==''?'126px':'126px'}" class="enterpriseDetails-fillDetails enterpriseDetails-fillDetails-headerPhoto">
                          <div class="enterpriseDetails-fillDetails-headerPhoto-after" style="cursor: pointer" @click="changeLogoBig()">
                            <img v-if="logoUrl!=''" :src="logoUrl" style="height: 100%;width: 100%;"/>
                          </div>
                        </div>
                      </div>
                      <div style="height: 24px;width: 165px;float: left;cursor: pointer;padding: 10px 0;position: relative;margin: 42px 0 42px 26px">
                        <img src="../../assets/enterpriseInfomationAddImgBtn.png" class="enterpriseInfomationAddImgBtn" alt="上传按钮">
                        <div v-if="logoUrl==null" style="height: 24px;float: left">点击上传</div>
                        <div v-if="logoUrl!=null" style="height: 24px;float: left">重新上传</div>
                        <input ref="fileInput" type="file" v-on:change="test()" class="enterpriseDetails-fillDetails-headerPhoto-file-bigImg"  style="cursor: pointer" >
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 营业执照、企业logo-->
                <!-- 企业性质、联系人-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue">企业性质</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <el-dropdown @command="handleNature" style="height: 36px;line-height: 36px;width: 99%;border: 1px solid #DFDFDF">
                        <span class="el-dropdown-link" style="margin-left: 1rem;display: inline-block;position: relative;width: 100%;height: 100%;">
                          {{nature}}<i class="el-icon-arrow-down el-icon--right" style="float: right;position: absolute;right: 30px;line-height: 36px;margin-top: 0;"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="project-dropdown">
                          <el-dropdown-item style="width:320px;" v-for="(item,index) in natureList" :key="index" :command="beforeHandleCommand(item.name, item.value)">{{item.name}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue">联系人</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <input v-model="linkMan" class="resume-fill-detils-releaseJobVue" type="text">
                    </div>
                  </div>
                </div>
                <!-- 企业性质、联系人-->
                <!-- 所属行业、联系方式-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue">所属行业</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <el-dropdown @command="handleTradeList" style="height: 36px;line-height: 36px;width: 99%;border: 1px solid #DFDFDF">
                        <span class="el-dropdown-link" style="margin-left: 1rem;display: inline-block;position: relative;width: 100%;height: 100%;">
                          {{trade}}<i class="el-icon-arrow-down el-icon--right" style="float: right;position: absolute;right: 30px;line-height: 36px"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="project-dropdown">
                          <el-dropdown-item style="width:320px;" v-for="(item,index) in tradeList" :key="index" :command="beforeHandleCommand(item.name, item.value)">{{item.name}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue">联系方式</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <input v-model="linkPhone" class="resume-fill-detils-releaseJobVue" type="text" style="width: 80%;float: left" maxlength="12">
                      <el-radio  v-if="jobCompany.isShowLinkPhone==1"  v-model="jobCompany.isShowLinkPhone" :label="1"   @click.native.prevent="change(1)" class="linkmanRadio">公开</el-radio>
                      <el-radio  v-if="jobCompany.isShowLinkPhone==2" v-model="jobCompany.isShowLinkPhone" :label="2"   @click.native.prevent="change(2)" class="linkmanRadio linkmanRadios">公开</el-radio>
                    </div>
                  </div>
                </div>
                <!-- 所属行业、联系方式-->
                <!-- 企业规模、职务-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue">企业规模</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <el-dropdown @command="handleScale" style="height: 36px;line-height: 36px;width: 99%;border: 1px solid #DFDFDF">
                        <span class="el-dropdown-link" style="margin-left: 1rem;display: inline-block;position: relative;width: 100%;height: 100%;">
                          {{scale}}<i class="el-icon-arrow-down el-icon--right" style="float: right;position: absolute;right: 30px;line-height: 36px"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item style="width:320px;" v-for="(item,index) in scaleList" :key="index" :command="beforeHandleCommand(item.name, item.value)">{{item.name}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue">职务</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <input v-model="post" class="resume-fill-detils-releaseJobVue" type="text">
                    </div>
                  </div>
                </div>
                <!-- 工作地址、详细地址-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue">工作地址</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue" style="display: flex">
                      <el-dropdown style="flex: 1;height: 36px;line-height: 36px;margin-right: 14px;border: 1px solid #DFDFDF;position: relative;" @command="handleArea">
                    <span class="el-dropdown-link" style="padding-left: 1rem;display: inline-block;width: 100%;height: 100%">
                      {{ area }}<i class="el-icon-arrow-down el-icon&#45;&#45;right" style="width:100%;line-height: 36px;position: absolute;right: 1em;text-align: right"></i>
                    </span>
                        <el-dropdown-menu slot="dropdown" class="project-dropdown">
                          <el-dropdown-item v-for="(item,index) in areaList" :key="index" style="width:6x8px;"
                                            :command="beforeHandleCommand(item.name, item.id)">{{ item.name }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-dropdown style="flex: 1;height: 36px;line-height: 36px;margin-right: 14px;border: 1px solid #DFDFDF;position: relative;" @command="handleCity">
                    <span class="el-dropdown-link" style="padding-left: 1rem;display: inline-block;width: 100%;height: 100%">
                      {{city}}<i class="el-icon-arrow-down el-icon&#45;&#45;right" style="width:100%;line-height: 36px;position: absolute;right: 1em;text-align: right"></i>
                    </span>
                        <el-dropdown-menu slot="dropdown" class="project-dropdown">
                          <el-dropdown-item v-for="(item,index) in cityList" style="width:68px;" :key="index" :command="beforeHandleCommand(item.name, item.id)">{{ item.name }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-dropdown style="flex: 1;height: 36px;line-height: 36px;margin-right: 14px;border: 1px solid #DFDFDF;position: relative;" @command="handleDistrict">
                    <span class="el-dropdown-link" style="padding-left: 1rem;display: inline-block;width: 100%;height: 100%">
                      {{district}}<i class="el-icon-arrow-down el-icon&#45;&#45;right" style="width:100%;line-height: 36px;position: absolute;right: 1em;text-align: right"></i>
                    </span>
                        <el-dropdown-menu slot="dropdown" class="project-dropdown">
                          <el-dropdown-item v-for="(item,index) in districtList" style="width:68px;" :key="index" :command="beforeHandleCommand(item.name, item.id)">{{ item.name }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <div class="resume-fillDetails-releaseJobVue" style="padding-bottom: 6px;">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue">详细地址</div>
                      <!-- <div class="asterisk">*</div> -->
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue" style="border: none;">
                      <input v-model="address" class="resume-fill-detils-releaseJobVue" type="text">
                    </div>
                  </div>
                </div>
                <!-- 工作地址、详细地址-->
                <!-- 企业标签-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue">企业标签</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue" style="border: none;" @click="changetabel()">
                      <input v-model="jobCompany.tagName" class="resume-fill-detils-releaseJobVue" type="text">
                    </div>
                  </div>
                </div>
                <!-- 企业标签-->
              </div>
              <!--企业基本信息-->
              <!--企业简介-->
              <div class="resume-modular-fillBox-releaseJobVue">
                <img src="../../assets/index-line.png" style="margin-bottom: 20px;" alt="">
                <!-- 求职类型、期望薪资-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue" style="padding-bottom: 6px;">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue" style="font-size: 22px;font-weight: bold;color: #000">企业简介</div>
                                            <div class="asterisk" style="font-size: 22px;font-weight: bold">*</div>
                    </div>
                    <div class="resume-fill-introduce-releaseJobVue">
                        <textarea type="text" class="resume-fill-textarea-releaseJobVue" name="" id="" cols="30" rows="6" style="" v-model="content"
                                  placeholder="请输入企业简介："></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <!--企业相册-->
              <div class="resume-modular-fillBox-releaseJobVue">
                <img src="../../assets/index-line.png" style="margin-bottom: 20px;" alt="">
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue" style="padding-bottom: 6px;">
                    <div class="fillBusinessDetails-name-enterPriseInfrmationVue">
                      <div class="fillResumeDetails-name-releaseJobVue" style="font-size: 22px;font-weight: bold;color: #000">企业相册</div>
                    </div>
                    <div class="resume-fill-introduce-releaseJobVue">
                      <div style="width: 165px;float: left;margin-right: 29px;" v-if="swiperList.length!==4">
                        <div :style="{'height': imageSrc==''?'126px':'126px'}" class="enterpriseDetails-fillDetails enterpriseDetails-fillDetails-headerPhoto">
                          <div class="enterpriseDetails-fillDetails-headerPhoto-after">
                            <img v-if="imageSrc!=''" :src="imageSrc" style="height:100%;width:100%;"/>
                          </div>
                          <span style="position: absolute;top: 0;height: 126px;width: 165px;">
                            <input type="file" id="file" accept="image/*" @change="add($event)" class="enterpriseDetails-fillDetails-headerPhoto-file"  style="cursor: pointer" >
                          </span>
                        </div>
                      </div>
                      <div v-if="swiperList.length!==undefined" style="float: left;">
                        <img v-for="(item, index) in swiperList" :src="item.imgUrl" style="width: 162px;height: 124px;border-radius: 8px;margin-right: 29px;cursor: pointer;" alt="" :key="index" @click="remove(index)" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 保存个人简历 -->
              <div class="resumeBtns-releaseJobVue">
                <button class="resumeSub-releaseJobVue resumeCheckBtnItem-releaseJobVue" @click="preserve()">保存</button>
                <button class="enterpriseInformationCancel-releaseJobVue resumeCheckBtnItem-releaseJobVue" @click="back()">取消</button>
              </div>
              <!-- 保存个人简历 -->
            </div>
          </div>
          <!--右 王-->
          <div class="personalCore-right-releaseJobVue" v-if="jobCompany.name!=null">
            <div class="personalCore-right-info-releaseJobVue">
              <img :src="userInfo.userPhoto"/>
              <div class="releaseJobVue-right-info-div-box">
                <div style="font-weight: bold;width: 144px;">{{userInfo.companyName}}</div>
                <div class="personalCores-right-info-div-vip" v-if="userInfo.isCompanyVip==true">企业会员</div>
              </div>
              <!-- <img src="../../assets/vip.png" alt="" class="enterpriseInformation-vip"> -->
            </div>
            <div class="personalCore-right-box">
              <div class="personalCore-right-boxs" style="margin-left: 32px;" @click="go()">
                <img src="../../assets/Enterprise-icon1.png" />
                <div>职位列表</div>
              </div>
              <div class="personalCore-right-boxs" style="margin-left: 24px;" @click="curriculumVitae()">
                <img src="../../assets/Enterprise-icon2.png" />
                <div>简历管理</div>
              </div>
              <div class="personalCore-right-boxs" style="margin-left: 32px;">
                <img src="../../assets/Enterprise-icon4.png" />
                <div>企业信息</div>
              </div>
              <div class="personalCore-right-boxs" style="margin-left: 24px;" @click="postRelease()">
                <img src="../../assets/Enterprise-icon3.png" />
                <div>发布岗位</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 大图展示营业执照-->
    <div class="mask_enterpriseInformationVue" v-if="licenseUrlBig==true">
        <div class="mask_enterpriseInformationVue_box">
            <div class="mask_enterpriseInformationVue_close" @click="closeBigImg" ><img src="../../assets/maskUrl-close.png" alt="关闭"></div>
            <div class="mask_enterpriseInformationVue_bigImg">
              <img v-if="licenseUrl!=''" :src="licenseUrl" alt="">
            </div>
        </div>
    </div>
    <!-- 大图展示Logo-->
    <div class="mask_enterpriseInformationVue" v-if="logoUrlBig==true">
      <div class="mask_enterpriseInformationVue_box">
        <div class="mask_enterpriseInformationVue_close" @click="closeBigImg" ><img src="../../assets/maskUrl-close.png" alt="关闭"></div>
        <div class="mask_enterpriseInformationVue_bigImg">
          <img v-if="logoUrl!=''" :src="logoUrl" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../../util/request'
export default {
  data () {
    return {
      userInfo: {},
      jobCompany: {},
      swiperList: [],
      linkMan: '',
      linkPhone: '',
      post: '',
      address: '',
      content: '',
      natureList: [],
      natureId: '',
      nature: '',
      scaleList: [],
      scale: '',
      scaleId: '',
      jobcategory: '全部',
      areaList: [],
      cityList: [],
      districtList: [],
      tradeList: [],
      trade: '',
      tradeId: '',
      typeIndex: 0,
      areaId: '',
      cityId: '',
      districtId: '',
      area: '',
      city: '',
      district: '',
      islabel: false,
      tabel: '',
      tabelId: '',
      imageSrc: '',
      cheshi: '',
      licenseUrl: '',
      logoUrl: '',
      tagId: '',
      licenseUrlBig: false, // 营业执照点击大图默认false
      logoUrlBig: false, // logo点击大图默认false
      backgroundDiv: { // 营业执照/logo背景图
        backgroundImage: 'url(' + require('../../assets/upload-enterprise-photo.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%'
      }
      // isShowLinkPhone: 2 // 显示1公开2不公开
    }
  },
  beforeCreate () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  methods: {
    getData () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/getCompany`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.jobCompany = res.data.data.jobCompany
          that.natureList = res.data.data.natureList
          that.areaList = res.data.data.areaList
          that.scaleList = res.data.data.scaleList
          that.tradeList = res.data.data.tradeList
          that.tagList = res.data.data.tagList
          that.tagList.forEach(function (item, index) {
            item.check = false
          })
          if (res.data.data.swiperList !== undefined) {
            that.swiperList = res.data.data.swiperList
          }
          if (that.jobCompany.tagName !== null) {
            var tagName = that.jobCompany.tagName.split(',')
            that.tagList.forEach(function (item, index) {
              tagName.forEach(function (i, j) {
                if (item.name === i) {
                  item.check = true
                }
              })
            })
          }
          if (that.jobCompany.license !== null) {
            that.licenseUrl = that.jobCompany.license
          }
          if (that.jobCompany.userPhoto !== null) {
            that.logoUrl = that.jobCompany.logoUrl
          }
          if (that.jobCompany.linkMan !== null) {
            that.linkMan = that.jobCompany.linkMan
          }
          if (that.jobCompany.tagId !== null) {
            that.tagId = that.jobCompany.tagId
          }
          if (that.jobCompany.linkPhone !== null) {
            that.linkPhone = that.jobCompany.linkPhone
          }
          if (that.jobCompany.isShowLinkPhone !== null) {
            that.isShowLinkPhone = that.jobCompany.isShowLinkPhone
          }
          if (that.jobCompany.post !== null) {
            that.post = that.jobCompany.post
          }
          if (that.jobCompany.address !== null) {
            that.address = that.jobCompany.address
          }
          if (that.jobCompany.content !== null) {
            that.content = that.jobCompany.content
          }
          if (that.jobCompany.nature !== null) {
            that.natureList.forEach(function (item, index) {
              if (item.value === that.jobCompany.nature) {
                that.nature = item.name
                that.natureId = item.value
              }
            })
          }
          if (that.jobCompany.trade !== null) {
            var trade = that.jobCompany.trade * 1
            that.tradeList.forEach(function (item, index) {
              if (item.value === trade) {
                that.trade = item.name
                that.tradeId = item.value
              }
            })
          }
          if (that.jobCompany.scale !== null) {
            that.scaleList.forEach(function (item, index) {
              if (item.value === that.jobCompany.scale) {
                that.scale = item.name
                that.scaleId = item.value
              }
            })
          }
          if (that.jobCompany.province !== '') { // 初始化，如果省份不为空的话
            var province = that.jobCompany.province * 1
            that.areaList.forEach(function (item, index) {
              if (item.id === province) {
                that.area = item.name
                that.areaId = that.jobCompany.province
                that.getCitys()
              }
            })
          } else {
            that.areaId = res.data.data.areaList[0].id
            that.getCitys()
          }
        },
        (err) => {
          that.$message.error(err)
        }
      )
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.userInfo = res.data.data.userInfo
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    // 获取市
    // getCity () {
    //   var that = this
    //   request({
    //     method: 'post',
    //     headers: {
    //       'Content-Type': 'application/json; charset=utf-8',
    //       token: '',
    //       Bearer: localStorage.getItem('token')
    //     },
    //     url: `/area/getAreaList`,
    //     data: JSON.stringify({
    //       id: that.areaId
    //     })
    //   }).then(
    //     (res) => {
    //       that.cityList = res.data.data.areaList
    //       that.cityId = res.data.data.areaList[0].id
    //       that.getDistrict()
    //     },
    //     (err) => {
    //       console.log(err)
    //     }
    //   )
    // },
    // 获取市
    getCitys () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/area/getAreaList`,
        data: JSON.stringify({
          id: that.areaId
        })
      }).then(
        (res) => {
          that.cityList = res.data.data.areaList
          if (that.jobCompany.city !== '') {
            var city = that.jobCompany.city * 1
            that.cityList.forEach(function (item, index) {
              if (item.id === city) {
                that.city = item.name
                that.cityId = that.jobCompany.city
              }
            })
          } else {
            that.city = res.data.data.areaList[0].name
            that.cityId = res.data.data.areaList[0].id
          }
          // if (that.jobCompany.city !== null) {
          //   var city = that.jobCompany.city * 1
          //   that.areaList.forEach(function (item, index) {
          //     // console.log(item.id,'item.id')
          //     // console.log(city,'city')
          //     if (item.id === city) {
          //       that.city = item.name
          //       that.cityId = that.jobCompany.city
          //       // console.log(that.city, that.cityId, '5555')
          //     }
          //   })
          // } else {
          //   console.log('==null')
          //   that.city = res.data.data.areaList[0].name
          //   that.cityId = res.data.data.areaList[0].id
          // }
          that.getDistricts()
        },
        (err) => {
          that.$message.error(err)
          // console.log(err)
        }
      )
    },
    // 获取区
    // getDistrict () {
    //   var that = this
    //   request({
    //     method: 'post',
    //     headers: {
    //       'Content-Type': 'application/json; charset=utf-8',
    //       token: '',
    //       Bearer: localStorage.getItem('token')
    //     },
    //     url: `/area/getAreaList`,
    //     data: JSON.stringify({
    //       id: that.cityId
    //     })
    //   }).then(
    //     (res) => {
    //       that.districtList = res.data.data.areaList
    //     },
    //     (err) => {
    //       console.log(err)
    //     }
    //   )
    // },
    // 获取区
    getDistricts () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/area/getAreaList`,
        data: JSON.stringify({
          id: that.cityId
        })
      }).then(
        (res) => {
          that.districtList = res.data.data.areaList
          if (that.jobCompany.area !== '') {
            var area = that.jobCompany.area * 1
            that.districtList.forEach(function (item, index) {
              if (item.id === area) {
                that.district = item.name
                that.districtId = that.jobCompany.districtId
              }
            })
          } else {
            that.district = res.data.data.areaList[0].name
            that.districtId = res.data.data.areaList[0].id
          }
        },
        (err) => {
          that.$message.error(err)
          // console.log(err)
        }
      )
    },
    changetabel () {
      this.islabel = true
    },
    select (index, check) {
      var that = this
      if (check === false) {
        that.tagList[index].check = true
        this.$forceUpdate()
      } else {
        that.tagList[index].check = false
        this.$forceUpdate()
      }
    },
    selectTabel () {
      var that = this
      var tabelName = []
      var tabelId = []
      that.tagList.forEach(function (item, index) {
        if (item.check === true) {
          tabelName.push(item.name)
          tabelId.push(item.id)
        }
      })
      var tabelNames = tabelName.join(',')
      var tabelIds = tabelId.join(',')
      that.jobCompany.tagName = tabelNames // 赋值企业标签
      that.comtagId = tabelNames
      that.tagId = tabelIds
      that.islabel = false
    },
    beforeHandleCommand (name, id) {
      return {
        id: id,
        name: name
      }
    },
    // 企业性质
    handleNature (command) {
      var that = this
      that.natureId = command.id
      that.nature = command.name
    },
    // 所属行业
    handleTradeList (command) {
      var that = this
      that.tradeId = command.id
      that.trade = command.name
    },
    // 企业规模
    handleScale (command) {
      var that = this
      that.scaleId = command.id
      that.scale = command.name
    },
    close () {
      this.isindustry = false
      this.islabel = false
    },
    add (e) {
      // let src = window.URL.createObjectURL(e.target.files[0])
      var reader = new FileReader()
      reader.onload = (e) => {
        var obj = {imgUrl: e.currentTarget.result}
        this.swiperList.push(obj)
      }
      reader.readAsDataURL(e.target.files[0])
    },
    remove (e) {
      this.$confirm('您确定删除该图片, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.swiperList.splice(e, 1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        // console.log(1)
      })
    },
    test () {
      const file = this.$refs.fileInput.files[0]
      const fileReader = new FileReader()
      fileReader.onload = (temp) => {
        this.logoUrl = temp.target.result
      }
      fileReader.readAsDataURL(file)
    },
    licenseUrls () {
      const file = this.$refs.fileInputs.files[0]
      const fileReader = new FileReader()
      fileReader.onload = (temp) => {
        this.licenseUrl = temp.target.result
      }
      fileReader.readAsDataURL(file)
    },
    // 省
    handleArea (command) {
      this.area = command.name
      this.areaId = command.id
      this.city = ''
      this.cityId = ''
      this.district = ''
      this.districtId = ''
      this.jobCompany.city = ''
      this.jobCompany.area = ''
      // this.getCity()
      this.getCitys()
    },
    // 市
    handleCity (command) {
      this.city = command.name
      this.cityId = command.id
      this.district = ''
      this.districtId = ''
      this.jobCompany.area = ''
      // this.getDistrict()
      this.getDistricts()
    },
    // 区
    handleDistrict (command) {
      this.district = command.name
      this.districtId = command.id
    },
    // 修改
    preserve () {
      var that = this
      if (that.natureId === '') {
        this.$message.error('请选择企业性质')
        return false
      }
      if (that.linkMan === '') {
        this.$message.error('请输入联系人')
        return false
      }
      if (that.tradeId === '') {
        this.$message.error('请选择所属行业')
        return false
      }
      if (that.linkPhone === '') {
        this.$message.error('请输入联系方式')
        return false
      }
      if (that.scaleId === '') {
        this.$message.error('请选择企业规模')
        return false
      }
      if (that.post === '') {
        this.$message.error('请输入职务')
        return false
      }
      if (that.content === '') {
        this.$message.error('请输入企业简介')
        return false
      }
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/addCompany`,
        data: JSON.stringify({
          name: that.jobCompany.name,
          code: that.jobCompany.code,
          address: that.address,
          // license: that.jobCompany.license,
          license: that.licenseUrl, // 营业执照
          logo: that.logoUrl, // logo
          nature: that.natureId,
          trade: that.tradeId,
          scale: that.scaleId,
          tagId: that.tagId,
          linkPhone: that.linkPhone,
          content: that.content,
          linkMan: that.linkMan,
          post: that.post,
          province: that.areaId,
          city: that.cityId,
          area: that.districtId,
          swiperList: that.swiperList,
          isShowLinkPhone: that.jobCompany.isShowLinkPhone
        })
      }).then(
        (res) => {
          if (res.data.code === 200) {
            that.$message.success('修改成功')
            this.$router.push({ path: '/enterpriseIndex' })
          }
        },
        (err) => {
          that.$message.error(err)
          // console.log(err)
        }
      )
    },
    go () {
      this.$router.push({ path: '/jobLists' })
    },
    postRelease () {
      this.$router.push({ path: '/releaseJob' })
    },
    goss () {
      this.$router.push({ path: '/enterpriseInformation' })
    },
    curriculumVitae () {
      this.$router.push({ path: '/curriculumVitae' })
    },
    back () {
      this.$router.go(-1)
    },
    change (e) { // isShowLinkPhone 1是公开2是不公开
      var that = this
      if (e === 2) {
        // that.isShowLinkPhone = 1
        that.jobCompany.isShowLinkPhone = 1
      } else {
        // that.isShowLinkPhone = 2
        that.jobCompany.isShowLinkPhone = 2
      }
    },
    changeUrlBig () { // 选择营业执照大图查看\
      if (this.licenseUrl != null) { // 如果营业执照不为null，蒙层看大图才会展示
        this.licenseUrlBig = true
      }
    },
    changeLogoBig () { // 选择logo大图查看
      if (this.logoUrl != null) { // 如果logo不为null，蒙层看大图才会展示
        this.logoUrlBig = true
      }
    },
    closeBigImg () { // 关闭查看的大图——营业执照和logo
      this.licenseUrlBig = false
      this.logoUrlBig = false
    }
  }
}
</script>

<style>
.enterpriseDetails-bottom{
  overflow: hidden;
  margin-top: 41px;
}
.businessDetails {
  overflow: hidden;
  margin-top: 36px;
}
.businessDetails-name {
  float: left;
  overflow: hidden;
  margin-left: 27px;
  margin-right: 18px;
  width: 80px;
}

.businessDetails-name div {
  float: left;
  font-size: 16px;
}
.businessDetails-content {
  float: left;
  overflow: hidden;
  width: 500px;
  position: relative;
}
/* 薪酬范围 */
.businessDetails-input {
  outline: 0;
  box-sizing: border-box;
  /* text-align:center; */
  font-size: 16px;
  height: 28px;
  border-radius: 4px;
  border: none;
  color: #6a6f77;
  display: block;
  outline: 0;
  padding: 0 1em;
  text-decoration: none;
  width: 100%;
  background-color: #FAFAFA;
}
.businessDetails-textarea {
  outline: 0;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 20px;
  border-radius: 4px;
  border: none;
  color: #6a6f77;
  display: block;
  outline: 0;
  padding: 1em 1em;
  text-decoration: none;
  width: 100%;
  background-color: #FAFAFA;
}
.businessDetails-pic {
  float: left;
}

.businessDetails-pic-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 58px;
  border: 1px dashed #8C8888;
  border-radius: 8px;
}

.businessDetails-picture img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.businessDetails-picture-txt {
  color: #BFBFBF;
  font-size: 10px;
  margin-top: 5px;
}
/* //选择标签 */
.label-selected {
  line-height: 28px;
  height: 28px;
  background-color: #FAFAFA;
  position: relative;
  margin-bottom: 10px;
}

.label-selected li {
  display: inline-block;
  height: 15px;
  line-height: 15px;
  font-size: 13px;
  padding: 3px 10px;
  border: 1px solid #0091FF;
  border-radius: 4px;
  margin-right: 10px;
  cursor: pointer;
  margin-top: 5px;
  color: #0091FF;
}

.labelItem {
  margin-bottom: 10px;
  display: none;
}

.label-item {
  border: 1px solid #e6e6e6;
  padding: 10px;
  border-radius: 0 2px 2px 0;
  position: relative;
  overflow: hidden;
  background-color: #ffffff;
}

.label-item li {
  display: inline-block;
  height: 27px;
  line-height: 27px;
  font-size: .8rem;
  padding: 0 1rem;
  border: 1px solid #e6e6e6;
  border-radius: 2px;
  cursor: pointer;
  margin-bottom: 5px;
  margin-left: 2px;
  color: #666666;
}

.label-item{
  color: #cccccc;
}
.selected {
  color: #cccccc;
}
/* 下拉箭头 */
.show-labelitem{
  float: right;
  line-height: 28px;
  height: 28px;
  display: flex;
  width: 28px;
  justify-content: center;
  align-items: center;
}
.show-labelitems{
  float: right;
  line-height: 28px;
  height: 28px;
  display: flex;
  width: 28px;
  justify-content: center;
  align-items: center;
}
.show-labelitem img{
  width: 11px;
}
.show-labelitems img{
  width: 11px;
}
.hide-labelitem{
  line-height: 28px;
  height: 28px;
  display: flex;
  width: 28px;
  justify-content: center;
  align-items: center;
}
.hide-labelitems{
  line-height: 28px;
  height: 28px;
  display: flex;
  width: 28px;
  justify-content: center;
  align-items: center;
}
.hide-labelitems{
  position: absolute;
  top: 0;
  right: 0;
}
.show-labelitems{
  position: absolute;
  top: 0;
  right: 0;
}
.hide-labelitems img{
  width: 18px;
}
.company-classification {
  width: 383px;
  background: #ffffff;
  height: 280px;
  position: relative;
}
/* 城市选择 */
.cityItem{
  border: none;
  background-color: #FAFAFA;
  height: 28px;
  line-height: 28px;
  color: #757575;
  width: 32.5%;
}
select{
  outline: none;
}
/* button*/
.project-dropdown{
  height:250px;
  overflow: auto;
}
.project-dropdown::-webkit-scrollbar{
  width: 5px;
  height: 5px;
  background-color: #F5F5F5;
}
.project-dropdown::-webkit-scrollbar-track{
  border-radius: 10px;
  background-color: #F5F5F5;
}
.shade{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .3);
  z-index: 998;
}
/* 职位标签 */
.releaseJob-tabel{
  z-index: 999;
  position: fixed;
  background-color: #fff;
  width: 40%;
  margin-left: 30%;
  top: 20%;
}
.releaseJob-tabel-title{
  font-weight: 550;
  margin-left: 30px;
  padding-top: 25px;
  font-size: 18px;
  overflow: hidden;
}
.releaseJob-tabel-title div{
  float: left;
}
.releaseJob-tabel-title img{
  float: right;
  width: 24px;
  height: 24px;
  margin-right: 16px;
}
.releaseJob-tabels{
  overflow: hidden;
  margin-top: 18px;
  margin-left: 30px;
}
.releaseJob-tabels-tabel{
  float: left;
  margin-right: 15px;
  margin-bottom: 15px;
  font-size: 14px;
  padding: 0 15px;
  border: 1px solid #E4E4E4;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  cursor: pointer;
  color: #757575;
}
.releaseJob-tabel-actives{
  border: 1px solid #587CF7;
  color: #587CF7;
}
.releaseJob-tabel-btns{
  margin-top: 20px;
  margin-bottom: 20px;
  overflow: hidden;
  margin-right: 30px;
}
.releaseJob-tabel-btns div:first-child{
  float: right;
  font-size: 14px;
  color: #fff;
  background-color: #587CF7;
  padding: 8px 25px;
  border-radius: 5px;
  margin-left: 15px;
  cursor: pointer;
}
.releaseJob-tabel-btns div:last-child{
  float: right;
  font-size: 14px;
  color: #587CF7;
  padding: 7px 24px;
  border-radius: 5px;
  margin-left: 15px;
  border: 1px solid #587CF7;
  cursor: pointer;
}
/*2023-4-26*/
.resume-box-releaseJobVue {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.resume-left-releaseJobVue{
  float: left;
  width: 857px;
  margin-right: 24px;
}
.resume-modular-filling-releaseJobVue {
  width: 857px;
  margin-bottom: 25px;
}
.resume-modular-fillBox-releaseJobVue {
  padding: 0 30px 20px 30px;
  background-color: #fff;
  margin-bottom: 26px;
}
.resume-modular-title-name-releaseJobVue{
  /*margin-top: 23px;*/
  /* margin-left: 41px; */
  height: 25px;
  line-height: 25px;
  margin-bottom: 21px;
  font-size: 18px;
  font-weight: 550;
}
.resume-modular-fill-releaseJobVue {
  display: flex;
}
.resume-fillDetails-releaseJobVue {
  display: flex;
  flex-direction: column;
  flex: 1;
  -webkit-box-flex: 1;
  overflow: hidden;
  margin-bottom: 26px;
  margin-right: 30px;
}
.fillBusinessDetails-name-enterPriseInfrmationVue {
  float: left;
  overflow: hidden;
  height: 22px;
  line-height: 22px;
  margin-bottom: 14px;
  /*width: 72px;*/
  /*width: 23%;*/
  color: #000;
  margin-right: 30px;
}
.fillResumeDetails-name-releaseJobVue {
  float: left;
  height: 22px;
  line-height: 22px;
  font-size: 16px;
}
.resume-fillDetails-content-releaseJobVue {
  float: left;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.resume-fillDetails-content-picker-releaseJobVue {
  width: 100% !important;
}

.resume-fillDetails-content-picker-releaseJobVue input {
  /*border: none;*/
  height: 36px;
  line-height: 36px;
  border: 1px solid #DFDFDF;
}
.resume-fill-detils-releaseJobVue {
  box-sizing: border-box;
  font-size: 16px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #DFDFDF;
  color: #6a6f77;
  display: block;
  outline: 0;
  padding: 0 1em;
  text-decoration: none;
  width: 100%;
}
.pull-down-icon-box-releaseJobVue{
  height: 36px;line-height: 36px;position: absolute;right: 10px;top: 0
}
.resume-fill-introduce-releaseJobVue {
  font-size: 14px;
  width: 100%;
}
.resume-fill-textarea-releaseJobVue {
  outline: 0;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;
  border-radius: 4px;
  border: none;
  border: 1px solid #DFDFDF;
  color: #6a6f77;
  display: block;
  outline: 0;
  padding: 1em 1em;
  text-decoration: none;
  /*width: 746px;*/
  width: 100%;
  resize:none;
  /*background: #F8F9FA;*/
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
.resume-modular-tabel-releaseJobVue {
  /*margin-left: 41px;*/
  overflow: hidden;
  /*height: 49px;*/
  padding-top: 9px;
  padding-bottom: 10px;
  /*background: #F8F9FA;*/
  border: 1px solid #DFDFDF;
  position: relative;
}

.resume-modular-tabel-releaseJobVue div {
  float: left;
  font-size: 14px;
  line-height: 30px;
  padding-right: 26px;
  /*border-right: 2px solid #979797;*/
  margin-right: 25px;
  padding-left: 1em;
  color: #6a6f77;
}
.resume-modular-add-releaseJobVue {
  width: 14px;
  position: absolute;
  right: 1em;
  margin-top: 8px;
}
/* 按钮 */
.resumeBtns-releaseJobVue {
  text-align: center;
  width: 100%;
  font-size: 16px;
  margin-top: 54px;
}

.resumeCheckBtnItem-releaseJobVue {
  width: 147px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  font-size: 16px;
  cursor: pointer;
}

.enterpriseInformationCancel-releaseJobVue {
  /*border: 1px solid #B0A7A7;*/
  color: #6D6D6D;
  background: #f6f6f6;
  height: 40px;
  line-height: 40px;
  border: 1px solid #979797;
  margin-left: 40px;
}

.resumeSub-releaseJobVue {
  color: #fff;
  border: 1px solid #587CF7;
  background: #587CF7;
}

.asterisk {
  color: #FF0000;
  float: left;
  margin-top: -1px;
  font-size: 17px;
}
/*.resume-modular-tabel-releaseJobVue div:last-child {*/
/*  border-right: none*/
/*}*/
.personalCore-right-releaseJobVue{
  width: 307px;
  float: left;
  height: 421px;
  background-color: #fff;
  border-radius: 10px;
}
.personalCore-right-info-releaseJobVue{
  overflow: hidden;
  width: 100%;
  height: 122px;
  border-bottom: 1px solid #ECECEC;
}
.personalCore-right-info-releaseJobVue img{
  float: left;
  width: 75px;
  height: 75px;
  margin-top: 27px;
  margin-left: 15px;
  margin-right: 30px;
  border-radius: 50%;
}
.releaseJobVue-right-info-div-box{
  float: left;
  margin-top: 34px;
  font-size: 18px;
}
.personalCore-right-box{
  width: 100%;
}
.releaseJobVue-right-boxs{
  width: 110px;
  height: 110px;
  display: inline-block;
  position: relative;
  /*margin-left: 44px;*/
  /*margin-top: 24px;*/
}
.releaseJobVue-right-boxs img{
  width: 100%;
  height: 100%;
}
.releaseJobVue-right-boxs div{
  position: absolute;
  top: 70px;
  left: 19px;
  font-size: 18px;
}
.enterpriseDetails-fillDetails-photo{
  width: 165px;
  height: 124px;
  /*border: 1px dashed #8C8888;*/
  border-radius: 8px;
}
/*photo*/
.enterpriseDetails-fillDetails {
  display: flex;
  flex-direction: column;
  flex: 1;
  -webkit-box-flex: 1;
  overflow: hidden;
  margin-bottom: 26px;
  margin-right: 30px;
}
.enterpriseDetails-fillDetails-headerPhoto {
  flex: 1;
  margin-bottom: 0;
  position: relative;
  margin-right: 0;
  width: 165px;
  border: 1px dashed #8C8888;
  border-radius: 8px;
}

.enterpriseDetails-fillDetails-headerPhoto-file{
  opacity: 0;
  width: 165px;
  height: 126px;
  position: absolute;
  top: 1px;
  z-index: 11;
}
.enterpriseDetails-fillDetails-headerPhoto-file-bigImg{
  opacity: 0;
  width: 165px;
  height: 44px;
  position: absolute;
  top: 0px;
  left: 0;
  z-index: 11;
}
.enterpriseDetails-fillDetails-headerPhoto-after{
  width: 162px;height: 124px;margin-top: 1px;margin-left: 1px;

}
.enterpriseDetails-fillDetails-headerPhoto-after:after{
  background: url("../../assets/upload-enterprise-photo.png");
  content: '';
  font-size: 12px;
  width: 162px;
  height: 123px;
  text-align: center;
  color: #c1c1c1;
  position: absolute;
  top: 2px;
  /*left: 1px;*/
  background-size: 100% 100%;
}
.enterpriseInformation-vip{
  width: 14px !important;
  height: 14px !important;
  position: absolute;
  left: 57px;
  top: 57px;
}
.personalCore-right-boxs{
  width: 110px;
  height: 110px;
  display: inline-block;
  position: relative;
  margin-left: 44px;
  margin-top: 24px;
  cursor: pointer;
}
.personalCore-right-boxs img{
  width: 100%;
  height: 100%;
}
.personalCore-right-boxs div{
  position: absolute;
  top: 70px;
  left: 19px;
  font-size: 18px;
}
.personalCores-right-info-div-vip{
  font-size: 12px;
  color: #E7BD7F;
  width: 71px;
  height: 19px;
  line-height: 19px;
  background-color: #373333;
  text-align: center;
  border-top-left-radius: 10px;
  border-bottom-right-radius: 10px;
  cursor: pointer;
}
.linkmanRadio{
  height: 24px;
  margin-top: 6px;
  margin-left: 10px;
}
.linkmanRadio .el-radio__inner{
  width: 24px;
  height: 24px;
}
.linkmanRadio.is-checked .el-radio__inner {
  border-color: #1FB72A !important;
  background: #1FB72A !important;
}
.linkmanRadios .is-checked .el-radio__inner {
  border-color: #DFDFDF !important;
  background: #fff !important;
}
.linkmanRadios .el-radio__input.is-checked+.el-radio__label {
  color: #DFDFDF !important;
}
.linkmanRadio .el-radio__inner:after {
  content: '✔';
  width: auto;
  height: auto;
  border-radius: 50%;
  background-color: unset;
  /*content: "";*/
  color: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%,-50%) scale(0);
  transform: translate(-50%,-50%) scale(0);
  -webkit-transition: -webkit-transform .15s ease-in;
  transition: -webkit-transform .15s ease-in;
  transition: transform .15s ease-in;
  transition: transform .15s ease-in,-webkit-transform .15s ease-in;
}
.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner{
  -webkit-box-shadow: 0 0 2px 2px #fff;
  box-shadow: 0 0 2px 2px #fff;
}
.mask_enterpriseInformationVue{
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.8);
}
.mask_enterpriseInformationVue_box{
  width: 100%;
  margin-top: 135px;
  display: flex;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mask_enterpriseInformationVue_close{
  width: 80%;
  height: 50px;
  text-align: right;
  margin-bottom: 30px;
  cursor: pointer;
}
.mask_enterpriseInformationVue_close img{
  width: 25px;
  height: 25px;
  padding-top: 12.5px;
  padding-right: 12.5px;
}
.mask_enterpriseInformationVue_bigImg{
  max-height: 450px;
}
.mask_enterpriseInformationVue_bigImg img{
  max-height: 450px;
}
.enterpriseInfomationAddImgBtn{
  width: 24px;
  height: 24px;
  float: left;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/enterprise/enterpriseInformation.vue